import type { SystemStyleObject } from '@chakra-ui/react';

export const loginCss: SystemStyleObject = {
  '&': {
    width: 'full',
    gap: 6,
  },

  '& .forgot-password': {
    justifyContent: 'center',
    width: 'full',
    fontSize: 'sm',
  },
};
